import { NonEntityUserGuard } from 'Src/ng2/routing/guards/non-entity-user-guard/non-entity-user-guard';

export const schoolPickerRoute = {
  path: 'school-picker',
  url: '/school-picker',
  canActivate: [NonEntityUserGuard],
  loadChildren: () => import('../../../../shell/school-picker/school-picker.module').then(m => m.SchoolPickerModule),
};
